import { useState } from 'react';
import { Title } from 'components/Title';

import BookingCalendar from './BookingCalendar';
export default function BcalenderPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="BcalenderPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="bcalender"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div>            <BookingCalendar />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
